var storefrontApp = angular.module("storefrontApp");
storefrontApp.controller("estimatedShippingController", [
    "$rootScope",
    "$scope",
    "$window",
    "$document",
    "productService",
    "commonService",
    "loaderService",
    function ($rootscope, $scope, $window, $document, productService, commonService, loaderService) {
        $scope.shippingMethods = {};
        $scope.selectedDest = "US";
        $scope.gotEstimate = false;
        $scope.selectedCountry;
        $scope.shippingErrors = false;
        $rootscope.shippingquantity = "1";

        $scope.showEstimateShipping = function (
            definition,
            vendorCode,
            amount,
            weight
        ) {
            $scope.isUSShipping = true;
            $scope.gotEstimate = false;
            $scope.shippingErrors = false;
            $scope.definition = definition;
            $scope.vendorCode = vendorCode;
            $scope.threadPrice = amount;
            $scope.threadUnitWeight = weight;
            $scope.shippingtext = "";
            $rootscope.shippingquantity = "1";

            return commonService.getCountries().then(function (response) {
                $scope.countries = response.data.filter(function (x) {
                    return x.code2 != "US";
                });
                $scope.selectedCountry = $scope.countries[0];
                $scope.toggleModal("shippingEstimate", true);
                document.getElementById("zipCode").value = "";
                document.getElementById("qty").value = "1";
            });
        };

        $scope.getShippingEstimate = function () {
            var shippingInformation = {};
            $scope.gotEstimate = false;
            $scope.hasShippingErrors = false;
            $scope.invalidPostalCode = false;
            shippingInformation.itemId = "";
            shippingInformation.definitionType = $scope.definition;
            shippingInformation.vendorCode = $scope.vendorCode;
            shippingInformation.regionCode = "";
            shippingInformation.quantity = parseInt($scope.shippingquantity);
            shippingInformation.ounces =
                $scope.threadUnitWeight * shippingInformation.quantity;
            shippingInformation.totalShipmentAmount = $scope.threadPrice;
            if ($scope.selectedDest == "US") {
                var zipCode = document.getElementById("zipCode").value;
                shippingInformation.countryCode = "US";
                shippingInformation.zipDestination = zipCode;
                shippingInformation.countryName = "United States";
                if (zipCode == "") {
                    $scope.hasShippingErrors = true;
                } else if (!/(^\d{5}$)|(^\d{5}-\d{4}$)/.test(zipCode)) {
                    $scope.invalidPostalCode = true;
                }
            } else {
                $scope.hasShippingErrors = false;
                shippingInformation.countryName = $scope.selectedCountry.name;
                shippingInformation.countryCode = $scope.selectedCountry.code2;
                shippingInformation.zipDestination = "";
            }
            if (!$scope.hasShippingErrors && !$scope.invalidPostalCode) {
                $document[0]
                    .getElementById("btn_estimate")
                    .classList.add("loading");

                loaderService.show();
                productService
                    .getShippingEstimate(shippingInformation)
                    .then(function (result) {
                        $scope.shippingEstimate = result.data[0].price.amount;
                        if ($scope.shippingEstimate == 0) {
                            $scope.shippingtext =
                                result.data[0].shippingMethodName;
                        } else {
                            $scope.shippingtext =
                                "Cost for shipping " +
                                $scope.shippingquantity +
                                " spool(s) via " +
                                result.data[0].shippingMethodName;
                        }
                        $document[0]
                            .getElementById("btn_estimate")
                            .classList.remove("loading");

                        loaderService.hide();
                    });
            }
        };

        $scope.countryChange = function (selectedCountry) {
            $scope.selectedCountry = selectedCountry;
        };

        $scope.destChange = function () {
            if ($rootscope.selectedDest == "US") {
                $rootscope.selectedDest = "Intl";
            } else {
                $rootscope.selectedDest = "US";
            }
        };
        $scope.quantityChange = function (shippingquantity) {
            $scope.shippingquantity = shippingquantity;
        };

        $scope.resetEstimateModal = function (key) {
            $scope.isUSShipping = true;
            $scope.gotEstimate = false;
            $scope.shippingErrors = false;
            $scope.shippingEstimate = 0.00;
            $scope.selectedDest = 'US';
            $rootscope.shippingquantity = "1";

            $scope.toggleModal(key);
        }
    },
]);
